<template>
  <span style="font-size:smaller; font-family: monospace;">{{seconds_to_display(seconds)}}</span>
</template>

<script>
import { mapState } from "vuex";

const seconds_to_display = (seconds, trim_seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - hours * 3600) / 60);
  const secs = Math.floor(seconds - hours * 3600 - minutes * 60);

  function padTo2(number) {
    if (number <= 99) {
      number = ("0" + number).slice(-2);
    }
    return number;
  }
  if (trim_seconds) {
    return padTo2(hours) + ":" + padTo2(minutes);
  } else {
    return padTo2(hours) + ":" + padTo2(minutes) + ":" + padTo2(secs);
  }
};

export default {
  name: "SecondsDisplay",
  props: ["seconds"],
  methods: {
    seconds_to_display(seconds) {
      // seconds_to_display is globally available from utils.js
      // eslint-disable-next-line no-undef
      return seconds_to_display(seconds, true);
    }
  }
};
</script>

<style scoped lang="less">
</style>

